import React, { useState } from 'react';
import { Row, Col, Divider, Dropdown, Button } from 'antd';
import {
	XTag,
	XPagination,
	XThemeTable,
	XThemeTableMobileCard,
	XThemeMobileListCard,
} from '../../styles/GlobalThemeStyle';
import { MoreOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { checkModulePermissions, toTitleCase } from '../../utils/helper';
import { XButtonImg } from '../../pages/Manage/ManageStyle';
import { XTheme2Table } from '../../styles/GlobalThemeStyleCQ';

const DataTable = (props) => {
	const {
		columns,
		tableData,
		totalRecords,
		setFilters,
		filters,
		state,
		page,
		showDeleteConfirm,
		handleEdit,
	} = props;

	const [id, setId] = useState('');
	const [name, setName] = useState('');
	const [itemData, setItemData] = useState({});
	const filteredColumns = columns.filter(
		(col) => col.dataIndex !== 'statusMobile',
	);

	const fetchCases = (pagination, _, sorter, ___) => {
		const queryParams = new URLSearchParams();

		// Append each filter to the query string
		Object.entries(filters).forEach(([key, value]) => {
			queryParams.append(key, value);
		});

		//Setting page filters: page size, sort, sort direction and limit in the query string
		queryParams.set(
			'page',
			pagination.current ? pagination.current : pagination,
		);
		queryParams.set('limit', pagination?.pageSize ?? 10);

		if (sorter && Object.keys(sorter).length > 0) {
			queryParams.set('sort', sorter ? sorter.field : 'createdAt');
			queryParams.set(
				'sortDirection',
				sorter ? sorter.order : filters.sortDirection,
			);
		} else {
			queryParams.set('sort', 'createdAt');
			queryParams.set('sortDirection', 'descend');
		}

		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
		setFilters({
			...filters,
			sort: sorter ? sorter.field : 'createdAt',
			sortDirection: sorter ? sorter.order : 'descend',
			page: pagination.current ? pagination.current : pagination,
			limit: pagination.pageSize ? pagination.pageSize : 10,
		});
	};

	const desiredColumnOrder = [
		'case_id',
		'createdAt',
		'hospital',
		'state',
		'insurance_company',
		'medical_coverage',
		'allocated',
	];
	const items = [
		{
			key: '1',
			label: (
				<div
					onClick={() => {
						handleEdit(itemData);
					}}
				>
					Edit
				</div>
			),
			icon: <img src="./images/pencil.svg" alt="" />,
		},
		{
			key: '2',
			label: (
				<div
					onClick={() => {
						showDeleteConfirm(id, name);
					}}
				>
					Delete
				</div>
			),
			icon: <img src="./images/delete-icon-card.svg" alt="" />,
		},
	];
	// Filter and sort the columns based on the desired order
	const orderedColumns = columns
		.filter((col) => desiredColumnOrder.includes(col.dataIndex))
		.sort(
			(a, b) =>
				desiredColumnOrder.indexOf(a.dataIndex) -
				desiredColumnOrder.indexOf(b.dataIndex),
		);

	const cardsToRender = (item) => {
		switch (page) {
			case 'case':
				return (
					<XThemeMobileListCard>
						<Link
							to={
								Array.isArray(item.case_id)
									? `${item.case_id[2]}/${item.case_id[0]}`
									: ''
							}
						>
							{/* {orderedColumns.map((col, index) => {
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<div key={index} className="column-data">
										<div className="column-title">
											{col.title}
										</div>
										<div className="column-value">
											{Array.isArray(dataValue)
												? dataValue[1]
												: dataValue}
										</div>
									</div>
								);
							})} */}

							<Row
								gutter={[10, 5]}
								className="align-items-center"
							>
								<Col xs={12}>
									<p className="para1">
										{item.patient_name &&
										Array.isArray(item.patient_name)
											? item.patient_name[1]
											: item.patient_name}
									</p>
								</Col>

								<Col xs={12}>
									<p className="para1">
										{Array.isArray(item.mrn)
											? item.mrn[1]
											: item.mrn}
									</p>
								</Col>

								{orderedColumns.map((col, index) => {
									if (
										col.dataIndex === 'action' ||
										col.dataIndex === 'mrn' ||
										col.dataIndex === 'patient_name' ||
										col.title === 'status'
									)
										return null;
									const dataIndex = col.dataIndex;
									const dataValue = item[dataIndex];
									return (
										<>
											<Col
												xs={
													dataIndex ===
														'insurance_company' ||
													dataIndex ===
														'medical_coverage'
														? 24
														: 12
												}
												className="my-1"
											>
												<p className="para2">
													{col.title}
												</p>

												<p className="para1">
													{Array.isArray(dataValue)
														? dataValue[1]
														: dataValue}
												</p>
											</Col>
										</>
									);
								})}
								<Col xs={12} className="text-end">
									{item.statusMobile ? (
										<XTag
											className={`${item.statusMobile} mb-2`}
										>
											{toTitleCase(item.statusMobile)}
										</XTag>
									) : item.action ? (
										item.action
									) : (
										<></>
									)}
								</Col>
							</Row>
						</Link>
						{item.action ? (
							<div className="mobileFancyCard">
								<Dropdown
									menu={{
										items: [
											{
												key: '1',
												label: (
													<>
														{item.action
															? item.action
															: ''}
													</>
												),
											},
										],
									}}
								>
									<Button
										shape="circle"
										size="large"
										icon={<MoreOutlined />}
									/>
								</Dropdown>
								{/* {item.action ? item.action : ''} */}
							</div>
						) : null}
					</XThemeMobileListCard>
				);
			case 'user-management':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]} className="align-items-center">
							{columns.map((col, index) => {
								if (
									col.dataIndex === 'organization' ||
									col.dataIndex === 'region' ||
									col.dataIndex === 'hospital' ||
									col.dataIndex === 'is_active' ||
									col.dataIndex === 'createdAt' ||
									col.dataIndex === 'action'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col xs={10}>
											<p className="para2 mb-1">
												{col.title}
											</p>
											<p className="para1 mb-2">
												{dataValue &&
												Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}

							<Col xs={4} className="text-end">
								{item.action ? (
									checkModulePermissions(
										'user-management',
									).sub_modules.includes('update-users') ? (
										<XButtonImg
											onClick={() => {
												handleEdit(item);
											}}
											type="text"
										>
											<img
												src="./images/pencil.svg"
												alt=""
											/>
										</XButtonImg>
									) : (
										<></>
									)
								) : (
									<></>
								)}
							</Col>

							{columns.map((col, index) => {
								if (
									col.dataIndex === 'userName' ||
									col.dataIndex === 'action' ||
									col.dataIndex === 'role'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col xs={24} sm={12}>
											<p className="para2 mb-1">
												{col.title}
											</p>
											<p className="para1 mb-2">
												{dataValue &&
												Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}
						</Row>
					</XThemeMobileListCard>
				);
			case 'role-management':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]}>
							<Col xs={20}>
								{columns.map((col, index) => {
									if (
										col.dataIndex === 'organization' ||
										col.dataIndex === 'action' ||
										col.dataIndex === 'modules' ||
										col.dataIndex === 'createdOn'
									)
										return null;
									return (
										<>
											<p className="para2 mb-1">
												{col.title}
											</p>
											<p className="para1 mb-2">
												{item.userName
													? item.userName
													: item.role}
											</p>
										</>
									);
								})}
							</Col>
							<Col xs={4} className="text-end">
								{item.action ? (
									checkModulePermissions(
										'user-management',
									).sub_modules.includes('update-users') ? (
										<XButtonImg
											onClick={() => {
												handleEdit(item);
											}}
											type="text"
										>
											<img
												src="./images/pencil.svg"
												alt=""
											/>
										</XButtonImg>
									) : (
										<></>
									)
								) : (
									<></>
								)}
							</Col>

							{columns.map((col, index) => {
								if (
									col.dataIndex === 'role' ||
									col.dataIndex === 'action'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col xs={24}>
											<p className="para2 mb-1">
												{col.title}
											</p>
											<p className="para1 mb-2">
												{dataValue &&
												Array.isArray(dataValue)
													? dataValue.map(
															(module, idx) => (
																<span key={idx}>
																	{module}
																	{idx <
																	dataValue.length -
																		1
																		? ' '
																		: ''}
																</span>
															),
													  )
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}
						</Row>
					</XThemeMobileListCard>
				);
			case 'insurance-company':
			case 'hospital':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]}>
							<Col xs={20}>
								<p className="para1">
									{item.name && Array.isArray(item.name)
										? item.name[1]
										: item.name}
								</p>
							</Col>
							<Col xs={4}></Col>

							<Col xs={24}>
								<p className="para1">
									{item.contact_person_email_address || ''}
								</p>
							</Col>

							{columns.map((col, index) => {
								if (
									col.dataIndex === 'action' ||
									col.dataIndex === 'name' ||
									col.dataIndex ===
										'contact_person_email_address'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col
											xs={
												dataIndex === 'address'
													? 24
													: 12
											}
											className="my-1"
										>
											<p className="para2">
												{col.title}:
											</p>

											<p className="para1">
												{dataValue &&
												Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}
						</Row>
						{item.action ? (
							checkModulePermissions(
								'hospital-management',
							).sub_modules.includes('update-hospitals') ? (
								<div className="mobileFancyCard">
									{/* <XButtonImg
												onClick={() => {
													handleEdit(item);
												}}
												type="text"
											>
												<img
													src="./images/pencil.svg"
													alt=""
												/>
											</XButtonImg> */}
									<Dropdown
										menu={{
											items: [
												{
													key: '1',
													label: (
														<div
															onClick={() => {
																handleEdit(
																	item,
																);
															}}
														>
															<img
																src="./images/pencil.svg"
																alt=""
																className="me-2 img-fluid"
															/>
															Edit
															{/* {item.action
																? item.action
																: ''} */}
														</div>
													),
												},
											],
										}}
									>
										<Button
											shape="circle"
											size="large"
											icon={<MoreOutlined />}
										/>
									</Dropdown>
								</div>
							) : (
								<></>
							)
						) : (
							<></>
						)}
					</XThemeMobileListCard>
				);
			case 'feedback':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]}>
							<Col xs={12}>
								<Link
									to={`${item.case_id[2]}/${item.case_id[0]}`}
								>
									<p className="para1">
										{item.patient_name &&
										Array.isArray(item.patient_name)
											? item.patient_name[1]
											: item.patient_name}
									</p>
								</Link>
							</Col>
							<Col xs={12} className="text-end">
								{item.statusMobile ? (
									<XTag
										className={`${item.statusMobile} mb-2`}
									>
										{toTitleCase(item.statusMobile)}
									</XTag>
								) : item.action ? (
									item.action
								) : (
									<></>
								)}
							</Col>
							<Col xs={12}>
								<p className="para1">
									{Array.isArray(item.mrn)
										? item.mrn[1]
										: item.mrn}
								</p>
							</Col>

							<Divider dashed className="mt-1 mb-3" />

							{columns.map((col, index) => {
								if (
									col.dataIndex === 'action' ||
									col.dataIndex === 'mrn' ||
									col.dataIndex === 'patient_name' ||
									col.dataIndex === 'status'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];

								return (
									<>
										<Col
											xs={
												dataIndex === 'feedback'
													? 24
													: 12
											}
											className="my-1"
										>
											<p className="para2">
												{col.title}:
											</p>
											<p className="para1">
												{Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}
							<Col xs={12} className="my-1">
								{item.action ? item.action : ''}
							</Col>
						</Row>
					</XThemeMobileListCard>
				);
			case 'module':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]} className="align-items-center">
							<Col xs={20}>
								<p className="para1">{item.module_name}</p>
							</Col>
							<Col xs={4} className="text-end">
								{item.statusMobile ? (
									<XTag
										className={`${item.statusMobile} mb-2`}
									>
										{toTitleCase(item.statusMobile)}
									</XTag>
								) : item.action ? (
									item.action
								) : (
									<></>
								)}
							</Col>

							<Divider dashed className="my-2" />

							{columns.map((col, index) => {
								if (
									col.dataIndex === 'action' ||
									col.dataIndex === 'module_name'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];

								return (
									<>
										<Col xs={24}>
											<p className="para2 mb-1">
												{col.title}:
											</p>
											<p className="para1 mb-2">
												{dataValue}
											</p>
										</Col>
									</>
								);
							})}
						</Row>
					</XThemeMobileListCard>
				);
			case 'region':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]}>
							{/* <Col xs={20}>
								<p className="para1">{item.name}</p>
							</Col> */}

							{columns.map((col, index) => {
								if (
									// col.dataIndex === 'name' ||
									col.dataIndex === 'action'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<Col xs={24} key={index}>
										<p className="para2">{col.title}</p>
										<p className="para1 mb-2">
											{dataValue &&
											Array.isArray(dataValue)
												? dataValue[1]
												: dataValue}
										</p>
									</Col>
								);
							})}

							{/* {columns.map((col, index) => {
								if (
									col.dataIndex === 'name' ||
									col.dataIndex === 'action'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col xs={24}>
											<p className="para1">
												{dataValue &&
												Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})} */}
							{item.action ? (
								<div className="mobileFancyCard">
									<Dropdown
										menu={{
											items,
										}}
									>
										<Button
											shape="circle"
											size="large"
											icon={<MoreOutlined />}
											onClick={() => {
												setId(item.key);
												setName(item.userName);
												setItemData(item);
											}}
										/>
									</Dropdown>
								</div>
							) : (
								<></>
							)}
						</Row>
					</XThemeMobileListCard>
				);
			case 'organization':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]}>
							{columns.map((col, index) => {
								if (
									col.dataIndex === 'action'
									// col.dataIndex === 'name' ||
									// col.dataIndex ===
									// 	'contact_person_email_address'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col
											xs={
												dataIndex === 'address'
													? 24
													: 24
											}
										>
											<p className="para2">
												{col.title}:
											</p>

											<p className="para1 mb-2">
												{dataValue &&
												Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}

							{item.action ? (
								checkModulePermissions(
									'organization-management',
								).sub_modules.includes(
									'update-organization',
								) ? (
									<div className="mobileFancyCard">
										<Dropdown
											menu={{
												items: [
													{
														key: '1',
														label: (
															<div
																onClick={() => {
																	handleEdit(
																		item,
																	);
																}}
															>
																<img
																	src="./images/pencil.svg"
																	alt=""
																	className="me-2 img-fluid"
																/>
																Edit
															</div>
														),
													},
												],
											}}
										>
											<Button
												shape="circle"
												size="large"
												icon={<MoreOutlined />}
											/>
										</Dropdown>
										{/* <XButtonImg
											onClick={() => {
												handleEdit(item);
											}}
											type="text"
										>
											<img
												src="./images/pencil.svg"
												alt=""
											/>
										</XButtonImg> */}
									</div>
								) : (
									<></>
								)
							) : (
								<></>
							)}
						</Row>
					</XThemeMobileListCard>
				);
			case 'reimbursements':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]}>
							{/* <p className="para1">
										{item.patient_name &&
										Array.isArray(item.patient_name)
											? item.patient_name[1]
											: item.patient_name}
									</p> */}

							{/* <Col xs={12} className="text-end">
								{item.statusMobile ? (
									<XTag
										className={`${item.statusMobile} mb-2`}
									>
										{toTitleCase(item.statusMobile)}
									</XTag>
								) : item.action ? (
									item.action
								) : (
									<></>
								)}
							</Col> */}
							{/* <Col xs={12}>
								<p className="para1">
									{Array.isArray(item.mrn)
										? item.mrn[1]
										: item.mrn}
								</p>
							</Col> */}

							{columns.map((col, index) => {
								if (
									[
										'action',
										//'mrn',
										//'patient_name',
										//'reimbursement',
									].includes(col.dataIndex) ||
									col.title === 'status'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col
											xs={
												dataIndex ===
													'insurance_company' ||
												dataIndex === 'hospital' ||
												dataIndex === 'medical_coverage'
													? 24
													: 12
											}
											className="my-1"
										>
											<Link
												to={
													Array.isArray(item.case_id)
														? `${item.case_id[2]}/${item.case_id[0]}`
														: ''
												}
											>
												<p className="para2">
													{col.title}:
												</p>

												<p className="para1">
													{Array.isArray(dataValue)
														? dataValue[1]
														: dataValue}
												</p>
											</Link>
										</Col>
									</>
								);
							})}

							<Col xs={12} className="my-1">
								{item.action ? item.action : ''}
							</Col>
						</Row>
					</XThemeMobileListCard>
				);
			case 'payer-configuration':
				return (
					<XThemeMobileListCard>
						<Row gutter={[10, 5]} className="align-items-center">
							{columns.map((col, index) => {
								if (
									[
										'action',
										'mrn',
										'patient_name',
										'reimbursement',
									].includes(col.dataIndex) ||
									col.title === 'status'
								)
									return null;
								const dataIndex = col.dataIndex;
								const dataValue = item[dataIndex];
								return (
									<>
										<Col
											xs={
												dataIndex ===
													'insurance_company' ||
												dataIndex === 'medical_coverage'
													? 24
													: 12
											}
											className="my-1"
										>
											<p className="para2">
												{col.title}:
											</p>

											<p className="para1">
												{Array.isArray(dataValue)
													? dataValue[1]
													: dataValue}
											</p>
										</Col>
									</>
								);
							})}

							{item.action ? (
								<div className="mobileFancyCard">
									<Dropdown
										menu={{
											items: [
												{
													key: '1',
													label: (
														<div>
															{item.action
																? item.action
																: ''}
														</div>
													),
												},
											],
										}}
									>
										<Button
											shape="circle"
											size="large"
											icon={<MoreOutlined />}
										/>
									</Dropdown>
								</div>
							) : (
								<></>
							)}
						</Row>
					</XThemeMobileListCard>
				);

			default:
				<></>;
				break;
		}
	};

	return (
		<>
			<Row gutter={16}>
				<Col xs={0} sm={0} md={24} lg={24} xl={24}>
					{/* Render the table for larger screens */}
					<XTheme2Table
						columns={filteredColumns}
						dataSource={tableData}
						loading={state === 'loading' ? true : false}
						// loading={state ? true : false}
						scroll={{ x: 991 }}
						pagination={{
							total: totalRecords,
							current: Number(filters.page),
							showSizeChanger: true,
							pageSize: filters.limit,
						}}
						className="customHorizontalScroll"
						onChange={fetchCases}
						showSorterTooltip={false}
					/>
				</Col>
				<Col xs={24} sm={24} md={0} lg={0} xl={0} className="p-0">
					{/* Render the cards for smaller screens */}
					{tableData.map((item, index) => {
						return (
							<XThemeTableMobileCard key={index}>
								{cardsToRender(item)}
							</XThemeTableMobileCard>
						);
					})}
				</Col>
				<Col
					xs={24}
					sm={24}
					md={0}
					lg={0}
					xl={0}
					className="text-center my-4"
				>
					<XPagination
						current={filters.page ? Number(filters.page) : 1}
						total={totalRecords}
						onChange={fetchCases}
						showSizeChanger
					/>
				</Col>
			</Row>
		</>
	);
};

export default DataTable;
